import { render, staticRenderFns } from "./NominacionIndex.vue?vue&type=template&id=09bd6e0e"
import script from "./NominacionIndex.vue?vue&type=script&lang=js"
export * from "./NominacionIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports